import store from "@/store";
import MinistryModule from "./store";
export default [
  {
    path: "/ministry",
    name: "ministry",
    redirect: { name: "ministry-dashboard" },
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("Ministry"))
        store.registerModule("Ministry", MinistryModule);
      next();
    },
    meta: {
      ministry: true,
    },
    children: [
      {
        path: "dashboard",
        name: "ministry-dashboard",
        component: () => import("./pages/dashboard/index.vue"),
        meta: {
          ministry: true,
        },
      },
      
      {
        path: "dashboard-events-log",
        name: "ministry-dashboard-events-log",
        component: () => import("./pages/dashboard/log-view/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "user-profile",
        component: () => import("@/modules/user-profile/moduleLayout.vue"),
        children: [
          {
            path: "profile",
            name: "ministry-user-profile",
            props: true,
            component: () =>
              import("@/modules/user-profile/pages/profile/index.vue"),
            meta: {
              ministry: true,
              slug: "ministry_profile",
            },
          },
        ],
      },
      {
        path: "ngos",
        component: () => import("./pages/ngos/index.vue"),
        meta: {
          ministry: true,
          slug: "ministry_ngos",
        },
      },

      {
        path: "ngos-requests",
        component: () => import("./pages/ngos-requests/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "accreditation-transactions",
        component: () => import("./pages/settings/settings-pages/accreditation-transactions"),
        
        meta: {
          ministry: true,
        },
      },
      {
        path: "accreditation-transactions/:id",
        props: true,
        component: () => import("./pages/settings/settings-pages/accreditation-transactions/showTransaction.vue"),
        meta: {
          ministry: true,
        },
        
      },
      // {
      //   path: "creation-requests",
      //   component: () => import("./pages/creation-requests/index.vue"),
        
      //   meta: {
      //     ministry: true,
      //   },
      // },
      {
        path: "creation-requests/:id",
        props: true,
        component: () => import("./pages/creation-requests/show.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "ngos-creation-requests",
        component: () => import("./pages/dashboard/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "advanced-reports",
        component: () => import("./pages/advanced-reports/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "ngos-communication",
        name: "ngos-communication",
        component: () => import("./pages/ngos-communication/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "ngos-communication/incentives",
        name: "communication-incentives",
        component: () =>
          import(
            "./pages/ngos-communication/communication-pages/incentives/index.vue"
          ),
        meta: {
          ministry: true,
          slug: "ministry_incentives_management_comm",
        },
      },
      {
        path: "ngos-communication/campaigns",
        name: "communication-campaigns",
        component: () =>
          import(
            "./pages/ngos-communication/communication-pages/campaigns/index.vue"
          ),
        meta: {
          ministry: true,
          slug: "ministry_accept_reject_campaigns_comm",
        },
      },
      {
        path: "settings",
        name: "ministry-settings",
        component: () => import("./pages/settings/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "settings/regulations",
        name: "settings-regulations",
        component: () =>
          import("./pages/settings/settings-pages/regulations/index.vue"),
        meta: {
          slug: "ministry_regulations",
          ministry: true,
        },
        beforeEnter(to, _, next) {
          if (!to.query.model) next({ ...to, query: { model: "law" } });
          else if (
            ["circular", "decision", "system", "law", "decree"].includes(
              to.query.model
            )
          )
            next();
          else next({ name: "error-404" });
        },
      },

      {
        path: "settings/regulations/:id",
        name: "settings-regulations-show",
        component: () =>
          import("./pages/settings/settings-pages/regulations/show.vue"),
        props: true,
        meta: {
          slug: "ministry_regulations",
          ministry: true,
        },
        beforeEnter(to, _, next) {
          if (!to.query.model) next({ ...to, query: { model: "law" } });
          else if (
            ["circular", "decision", "system", "law", "decree"].includes(
              to.query.model
            )
          )
            next();
          else next({ name: "error-404" });
        },
      },
      {
        path: "settings/image-slider",
        name: "settings-image-slider",
        component: () =>
          import("./pages/settings/settings-pages/image-slider/index.vue"),
        meta: {
          slug: "ministry_slider",
          ministry: true,
        },
      },
      // {
      //   path: "settings/shaml-forms",
      //   name: "settings-shaml-forms",
      //   component: () =>
      //     import("./pages/settings/settings-pages/shaml-forms/index.vue"),
      //   meta: {
      //     slug: "ministry_slider",
      //     ministry: true,
      //     title: "استمارات شمل",
      //     breadCrumb: [
      //       {
      //         text: "الإعدادات",
      //         to: { name: "ministry-settings" },
      //       },
      //       {
      //         text: "استمارات شمل",
      //         active: true,
      //       },
      //     ],
      //   },
      // },
      // {
      //   path: "settings/shaml-forms/:id",
      //   name: "settings-shaml-forms-view",
      //   component: () =>
      //     import("./pages/settings/settings-pages/shaml-forms/show.vue"),
      //   props: true,
      //   meta: {
      //     slug: "ministry_slider",
      //     ministry: true,
      //     title: "استمارات شمل",
      //     breadCrumb: [
      //       {
      //         text: "الإعدادات",
      //         to: { name: "ministry-settings" },
      //       },
      //       {
      //         text: "استمارات شمل",
      //         to: { name: "settings-shaml-forms" },
      //       },
      //     ],
      //   },
      // },
      {
        path: "settings/instructions",
        name: "settings-instructions",
        component: () =>
          import("./pages/settings/settings-pages/instructions/index.vue"),
        meta: {
          ministry: true,
          slug: "ministry_instructions",
        },
      },
      {
        path: "settings/instructions/:id",
        name: "settings-instructions-show",
        props: true,
        component: () =>
          import("./pages/settings/settings-pages/instructions/show.vue"),
        meta: {
          ministry: true,
          slug: "ministry_instructions",
        },
      },
      {
        path: "settings/holidays",
        name: "settings-holidays",
        component: () =>
          import("./pages/settings/settings-pages/holidays/index.vue"),
        meta: {
          ministry: true,
          slug: "ministry_annual_holidays",
        },
      },
      {
        path: "settings/events",
        name: "settings-events",
        component: () => import("./pages/settings/settings-pages/events"),
        meta: {
          ministry: true,
          slug: "ministry_events",
        },
      },
      {
        path: "settings/faq",
        name: "settings-faq",
        component: () => import("./pages/settings/settings-pages/faq"),
        meta: {
          ministry: true,
          slug: "ministry_Q&A",
        },
      },
      {
        path: "settings/faq-categories",
        name: "settings-faq-categories",
        component: () =>
          import("./pages/settings/settings-pages/faq-categories"),
        meta: {
          ministry: true,
          slug: "ministry_question_categories",
        },
      },
      {
        path: "settings/indexes",
        name: "settings-indexes",
        component: () => import("./pages/settings/settings-pages/indexes"),
        meta: {
          ministry: true,
          slug: "ministry_indexes",
        },
      },
      {
        // path: "settings/ngos-management",
        path :"ngos-communication/ngos-management",
        name: "settings-ngos-management",
        component: () =>
          import("./pages/settings/settings-pages/ngos-management"),
        meta: {
          ministry: true,
          slug: "ministry_immediate_ngos",
        },
      },
      {
        // path: "settings/ngos-validation",
        path: "ngos-communication/ngos-validation",
        name: "settings-ngos-validation",
        component: () =>
          import("./pages/settings/settings-pages/ngos-validation"),
        meta: {
          ministry: true,
          slug: "ministry_ngos_validation",
        },
      },
      {
        // path: "settings/ngos-validation-report",
        path: "ngos-communication/ngos-validation-report",
        name: "settings-ngos-validation-report",
        component: () =>
          import("./pages/settings/settings-pages/ngos-validation-report"),
        meta: {
          ministry: true,
          slug: "ministry_ngos_validation_report",
        },
      },
      {
        path: "settings/indexes/:slug",
        name: "index-view",
        props: true,
        component: () =>
          import("./pages/settings/settings-pages/indexes/index-view.vue"),
        meta: {
          slug: "ministry_indexes",
          ministry: true,
        },
      },
      {
        path: "settings/users",
        name: "settings-users",
        component: () => import("./pages/settings/settings-pages/users"),
        // redirect: "/ministry/settings/users/ngo-users",
        children: [
          {
            path: "ministry-users",
            name: "ministry-users-management",
            component: () =>
              import(
                "./pages/settings/settings-pages/users/ministry-users.vue"
              ),
            meta: {
              slug: "ministry_users_rp",
              ministry: true,
            },
          },
          {
            path: "ngo-users",
            name: "ngo-users-management",
            component: () =>
              import("./pages/settings/settings-pages/users/ngo-users.vue"),
            meta: {
              slug: "ministry_ngo_users_rp",
              ministry: true,
            },
          },
        ],
        meta: {
          ministry: true,
          // slug: "ministry_ngo_users_rp",
        },
      },
      {
        path: "settings/ngo-user/:id",
        name: "settings-ngo-users-show",
        props: true,
        component: () =>
          import(
            "./pages/settings/settings-pages/users/users-view/NgoUserView.vue"
          ),
        meta: {
          slug: "ministry_ngo_users_rp",
          ministry: true,
        },
      },
      {
        path: "settings/ministry-user/:id",
        name: "settings-ministry-users-show",
        props: true,
        component: () =>
          import(
            "./pages/settings/settings-pages/users/users-view/MinistryUserView.vue"
          ),
        meta: {
          slug: "ministry_users_rp",
          ministry: true,
        },
      },
      {
        path: "settings/roles",
        name: "settings-roles",
        component: () =>
          import("./pages/settings/settings-pages/roles/index.vue"),
        meta: {
          slug: "ministry_roles_rp",
          title: "الإعدادات",
          ministry: true,
          breadCrumb: [
            {
              text: "الأدوار",
              active: true,
            },
          ],
        },
      },
      {
        path: "settings/usersAvailability",
        name: "settings-usersAvailability",
        component: () =>
           import("./pages/settings/settings-pages/users-availability/index.vue"),
        meta: {
          slug: "ministry_users_availability",
          title: "الإعدادات",
          ministry: true,
          breadCrumb: [
            {
              text: "توفر المستخدمين",
              active: true,
            },
          ],
        },
      },
      {
        // mediation-requestes
        // old path
        // path: "settings/mediation-requestes",

        // new path
        path:"ngos-communication/mediation-requestes",
        name: "settings-mediation-requestes",
        component: () =>
          import(
            "./pages/settings/settings-pages/mediation-requestes/index.vue"
          ),
        meta: {
          slug: "ministry_mediation_request",
          ministry: true,
        },
      },
      {
        // old
        // path: "settings/mediation-requestes/:id",
        // new
        path: "ngos-communication/mediation-requestes/:id",
        name: "settings-mediation-requestes-show",
        props: true,
        component: () =>
          import(
            "./pages/settings/settings-pages/mediation-requestes/show-mediation-requestes.vue"
          ),
        meta: {
          slug: "ministry_mediation_request",
          ministry: true,
        },
      },
      {
        path:"ngos-communication/financial-grants",
        name: "settings-financial-grants",
        component: () =>
          import(
            "./pages/settings/settings-pages/financial-grants/index.vue"
          ),
        meta: {
          slug: "ministry_financial_grants",
          ministry: true,
        },
      },
      {
        // Accreditation transactions
        path: "settings/accreditation-transactions",
        name: "settings-accreditation-transactions",
        component: () =>
          import(
            "./pages/settings/settings-pages/accreditation-transactions/index.vue"
          ),
        meta: {
          slug: "ministry_transaction_requests",
          ministry: true,
        },
      },
      {
        path: "transactions/description",
        name: "transactions-description",
        component: () =>
          import(
            "./pages/settings/settings-pages/transaction-management/transaction-description/index.vue"
          ),
        meta: {
          slug: "ministry_transaction_types",
          ministry: true,
        },
      },
      {
        path: "transactions/actions",
        name: "transactions-actions",
        component: () =>
          import(
            "./pages/settings/settings-pages/transaction-management/transaction-actions/index.vue"
          ),
        meta: {
          slug: "ministry_action_types",
          ministry: true,
        },
      },
      {
        path: "notifications",
        name: "notifications",
        component: () => import("./pages/notifications/index.vue"),
        meta: {
          slug: "ministry_notifications_managment",
          ministry: true,
        },
      },
      {
        path: "ngos-data",
        name: "ngos-data",
        component: () => import("./pages/ngos-data/index.vue"),
        meta: {
          ministry: true,
        },
      },
      {
        path: "docs",
        component: () => import("@/modules/docs/moduleLayout.vue"),
        children: [
          {
            props: true,
            path: ":slug",
            name: "ministry-docs",
            component: () => import("@/modules/docs/pages/docs-page/index.vue"),
            meta: {
              ministry: true,
            },
          },
        ],
        meta: {
          ministry: true,
        },
      },

      {
        path: "add-role/:slug",
        name: "add-role",
        component: () =>
          import("./pages/settings/settings-pages/roles/create-role.vue"),
        meta: {
          title: "الإعدادات",
          ministry: true,
          breadCrumb: [
            {
              text: "الأدوار",
              active: true,
            },
            {
              text: "إضافة دور",
              active: true,
            },
          ],
        },
      },
      {
        path: "update-role/:slug/:id",
        name: "update-role",
        props: true,
        component: () =>
          import("./pages/settings/settings-pages/roles/create-role.vue"),
        meta: {
          title: "الإعدادات",
          ministry: true,
          breadCrumb: [
            {
              text: "الأدوار",
              active: true,
            },
            {
              text: "تعديل دور",
              active: true,
            },
          ],
        },
      },
      {
        path: "permissions-user/:id",
        name: "permissions-user",
        component: () =>
          import("./pages/settings/settings-pages/roles/show-role.vue"),
        props: true,
        meta: {
          title: "الإعدادات",
          ministry: true,
          breadCrumb: [
            {
              text: "الأدوار",
              active: true,
            },
            {
              text: "الصلاحيات",
              active: true,
            },
          ],
        },
      },
      {
        path: "ngos-data/:slug/:id",
        name: "report-view",
        component: () => import("./pages/ngos-data/ngos-data-view.vue"),
        props: (route) => ({
          id: route.params.id,
          slug: route.params.slug,
        }),
        meta: {
          title: "المنظمات",
          ministry: true,
          breadCrumb: [
            {
              text: "بيانات المنظمات",
              active: true,
            },
            {
              text: "المنظمات",
              active: true,
            },
          ],
        },
      },
      {
        path: "ngos-data/:view",
        component: () => import("./pages/ngos-data/ngos-data-list.vue"),
        props: (route) => ({
          page: route.query.page,
          size: route.query.size,
          sortBy: route.query.sortBy,
          sortDesc: route.query.sortDesc,
          searchKey: route.query.searchKey,
          searchField: route.query.searchField,
          view: route.params.view,
        }),
        meta: {
          title: "المنظمات",
          ministry: true,
          breadCrumb: [
            {
              text: "بيانات المنظمات",
              active: true,
            },
            {
              text: "المنظمات",
              active: true,
            },
          ],
          tableFields: ["name"],
        },
      },
      {
        path: "ngos-data-new/:view",
        component: () => import("./pages/ngos-data/ngos-data-list-new.vue"),
        props: (route) => ({
          page: route.query.page,
          size: route.query.size,
          sortBy: route.query.sortBy,
          sortDesc: route.query.sortDesc,
          searchKey: route.query.searchKey,
          searchField: route.query.searchField,
          view: route.params.view,
        }),
        meta: {
          title: "المنظمات",
          ministry: true,
          breadCrumb: [
            {
              text: "بيانات المنظمات",
              active: true,
            },
            {
              text: "المنظمات",
              active: true,
            },
          ],
        },
      },
      {
        path: "ministry-notifications",
        name: "ministry-notifications",
        component: () =>
          import("@/modules/notifications/pages/ministry-notifications"),
        meta: {
          ministry: true,
        },
      },
    ],
  },
];
